export const slidersData = [
  {
    id: 1,
    colour: "blue",
    title: "Graphic Designer",
    years: "1994 - 2015",
    tech: ["Aldus PageMaker 4.0\n", "Aldus FreeHand 3.1\n", "QuarkXPress 3.3", "Adobe Photoshop 2.5", "Macintosh Plus"],
    src: "assets/steve_graphic_designer_square.jpg",
  },
  {
    id: 2,
    colour: "yellow",
    title: "Sign Maker",
    years: "2001 - 2013",
    tech: ["Roland VersaCAMM 300", "Epson Stylus Pro 7600", "Adobe Illustrator CS4", "Adobe Photoshop CS4", "iMac 27"],
    src: "assets/SudburySteve.jpg",
  },
  {
    id: 3,
    colour: "green",
    title: "Manufacturing Tech",
    years: "2013 - 2017",
    tech: ["Gibben Panel Saws", "Holzmann Edgebanders", "Drill Presses", "Lithium Battery Production"],
    src: "assets/steve_in_factory.jpg",
  },
];
